export default () => ({
  sectors: null,
  sectorList: null,
  agencyList: null,
  agencies: {},
  loading: false,
  instanceId: null,
  currentSector: null,
  currentAgency: null,
  isFormBackendValidated: false,
  editingAgencyVaccineException: null,
});
